import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Route } from 'react-router-dom';
import { Button, InputGroup, FormControl, Dropdown, DropdownButton } from 'react-bootstrap';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import PageComponent from '../components/PageComponent';
import AppStorage from '../config/AppStorage';
import Labels from '../Labels';
import Routes from '../config/Routes';

export default class AdminPage extends PageComponent {

  static PageInfo = {

    path: "/Admin",
    name: "menu.admin",
    permission: { "CONFIGURATION": true },
    access: { 1: true },
    icon: "cogs"
  }

  options = [{
    label: "menu.adminusers",
    path: "/Admin/Users",
    icon: "users"
  }, {
    label: "menu.brands",
    path: "/Admin/Brands",
    icon: "tags"
  }, {
    label: "menu.stategroups",
    path: "/Admin/attributes",
    icon: "cubes"
  }]

  constructor(props) {
    super(props);
    this.state.user = global.user;
  }

  render() {
    return (
      <Container context={this.constructor}>
        <div className="generics_panels">
          <div className="generics_panels_sizeless">
            <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
            {/* <div>
              <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("admin.company")}</div>
                <div className="generics_infobox_value">{this.state.user.mainCompany.name}</div>
              </div>
              <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("information.DOC_CNPJ")}</div>
                <div className="generics_infobox_value">{this.state.user.mainCompany.criticalValue}</div>
              </div>
              <div style={{ clear: "both" }}></div>
            </div> */}
          </div>
          <div className="generics_panels_flex1">
            <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("admin.options")}</span></div>
            {Routes.getChildren(AdminPage).map((item) =>
              <Link to={item.PageInfo.path} className="generics_listing_item" >
                <FontAwesomeIcon icon={item.PageInfo.icon} className="generics_listing_item_icon" />
                <div className="generics_listing_content" >
                  <div className="generics_listing_item_title" >{Labels.GetLabel(item.PageInfo.name)}</div>
                </div>
              </Link>
            )}
          </div>
        </div>
      </Container>
    );
  }
} 